import { render, staticRenderFns } from "./rental-contract.vue?vue&type=template&id=5021f42a&"
import script from "./rental-contract.vue?vue&type=script&lang=js&"
export * from "./rental-contract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports